export default {
  drawPoster() {
    const map = this.currentMap;
    const canvas = this.$refs.canvasPoster;
    const ctx = canvas.getContext("2d");
    let bkData = JSON.parse(sessionStorage.getItem("xfsbk_data"));

    function latLngToPixel(latLng) {
      return map.lngLatToContainer(latLng);
    }

    // 使用 boundaryDots 来确定画布的边界
    const boundaryDots = bkData.dots.split("-").map((x) => {
      const lngLat = x.split("|").map(Number);
      return latLngToPixel(lngLat);
    });

    // 计算边界框
    let minX = Math.min(...boundaryDots.map((dot) => dot.x));
    let maxX = Math.max(...boundaryDots.map((dot) => dot.x));
    let minY = Math.min(...boundaryDots.map((dot) => dot.y));
    let maxY = Math.max(...boundaryDots.map((dot) => dot.y));

    // 设置 canvas 大小为边界框的大小
    canvas.width = maxX - minX + 200;
    canvas.height = maxY - minY + 200;

    // 定义向下移动的像素值
    const offsetY = 20; // 假设我们向下移动20像素

    // 绘制背景
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height + offsetY); // 增加offsetY

    // 绘制边界多边形（向下移动）
    ctx.beginPath();
    boundaryDots.forEach((dot, index) => {
      const x = dot.x - minX;
      const y = dot.y - minY + offsetY; // 添加offsetY
      if (index === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    });
    ctx.closePath();
    ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
    ctx.fill();
    ctx.strokeStyle = "#333333";
    ctx.stroke();

    // 绘制其他多边形（向下移动）
    let cells = bkData && bkData.cells;
    if (cells) {
      cells.forEach((element) => {
        let dots = element.dots.split("-").map((x) => {
          const lngLat = x.split("|").map(Number);
          const pixel = latLngToPixel(lngLat);
          return {
            x: pixel.x - minX,
            y: pixel.y - minY + offsetY, // 添加offsetY
          };
        });

        ctx.beginPath();
        dots.forEach((dot, index) => {
          if (index === 0) {
            ctx.moveTo(dot.x, dot.y);
          } else {
            ctx.lineTo(dot.x, dot.y);
          }
        });
        ctx.closePath();

        ctx.fillStyle = element.type.slice(0, 7);
        ctx.fill();
        ctx.strokeStyle = "#333333";
        ctx.stroke();
      });
    }

    // 调用绘制图例的方法（向下移动）
    this.drawLegend(ctx, canvas, offsetY);

    // 导出为图片
    this.mpCode = canvas.toDataURL("image/png");
  },

  drawLegend(ctx, canvas) {
    const rectWidth = 20;
    const rectHeight = 10;
    const textX = rectWidth + 20;
    const textY = 15;
    const lineHeight = 25;
    const margin = 200; // 图例与画布边缘的间距

    // 计算图例的起始位置（右下角）
    let legendX = canvas.width - margin + 10;
    let legendY = canvas.height - margin - 20;

    this.colorKgMap.forEach((item, index) => {
      const y = legendY + index * lineHeight;

      // 绘制矩形
      ctx.fillStyle = item.color;
      ctx.fillRect(legendX, y, rectWidth, rectHeight);

      // 绘制文字
      ctx.fillStyle = "#000000";
      ctx.font = "14px Arial";
      ctx.fillText(item.txt + "用地", legendX + textX, y + rectHeight);
    });
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindPoster.js